import React from 'react';

// Client-side personality definitions (just for UI)
const PersonalityType = {
    CASUAL: 'CASUAL',
    SCHOLARLY: 'SCHOLARLY',
    STORYTELLER: 'STORYTELLER',
    PRACTICAL: 'PRACTICAL'
};

const PersonalityOptions = {
    [PersonalityType.CASUAL]: {
        name: 'Casual',
        tagline: 'Pop culture references and chill vibes',
        icon: '😎'
    },
    [PersonalityType.SCHOLARLY]: {
        name: 'Scholarly',
        tagline: 'Academic depth with etymological insights',
        icon: '🎓'
    },
    [PersonalityType.STORYTELLER]: {
        name: 'Storyteller',
        tagline: 'Learn through memorable stories',
        icon: '📚'
    },
    [PersonalityType.PRACTICAL]: {
        name: 'Practical',
        tagline: 'Direct, actionable, results-focused',
        icon: '⚡'
    }
};

function PersonalitySelector({ selectedPersonality, onPersonalityChange, disabled = false }) {
    const handleChange = (event) => {
        onPersonalityChange(event.target.value);
    };

    const selectedOption = PersonalityOptions[selectedPersonality];

    // Helper function to capitalize first letter only
    const capitalizeFirst = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    return (
        <div className="personality-selector">
            <div className="custom-select-wrapper">
                <select
                    id="personality-dropdown"
                    value={selectedPersonality}
                    onChange={handleChange}
                    disabled={disabled}
                    className="personality-dropdown"
                >
                    {Object.entries(PersonalityOptions).map(([key, description]) => (
                        <option key={key} value={key}>
                            {description.icon} {description.name} - {description.tagline}
                        </option>
                    ))}
                </select>
                <div className="selected-display" aria-hidden="true">
                    <span className="selected-display-icon">{selectedOption?.icon}</span>
                    <span className="selected-display-text">{capitalizeFirst(selectedPersonality)}</span>
                </div>
            </div>
        </div>
    );
}

export { PersonalityType, PersonalityOptions };
export default PersonalitySelector;